import * as Yup from "yup";

const phoneNumberSchema = Yup.object({
  phoneNumber: Yup.string()
    .required("Phone Number is Required")
    .matches(/^[6-9]\d{9}$/, "Please enter a valid phone number")
    .length(10, "Phone Number should be 10 Digits"),
});

export { phoneNumberSchema };